"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MainContainer = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
var MainContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n  border-radius: 16px;\n  width: fit-content;\n  height: fit-content;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 16px;\n  border-radius: 16px;\n  width: fit-content;\n  height: fit-content;\n"])));
exports.MainContainer = MainContainer;
var templateObject_1;
//# sourceMappingURL=styles.js.map